import {
  Alert,
  AlertIcon,
  Box,
  BoxProps,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Input,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import { UserScopes } from '@simplyanvil/smartparse-types';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
// import { useMutation } from '@apollo/client';
// import { UPDATE_ORGANISATION } from '../../graphql/mutations';
import FeatureGuard from '../FeatureGuard';
import useToggle from '../../hooks/useToggle';
import { AuthStateContext } from '../../contexts/AuthContext';

const PricingWrapper = (props: BoxProps & { highlight?: boolean }) => {
  const { highlight, ...rest } = props;

  const popularStyles: BoxProps = {
    borderWidth: '2px',
    borderColor: 'blue.300'
  };

  const styles = highlight ? popularStyles : null;

  return (
    <Box
      w='full'
      mx='auto'
      bg={useColorModeValue('brand.100', 'brand.800')}
      px='10'
      pt='8'
      pb='8'
      rounded='lg'
      shadow='base'
      position='relative'
      {...styles}
      {...rest}
    />
  );
};

const UpdateOrganization = () => {
  const { currentOrganisation } = useContext(AuthStateContext);
  const [editMode, toggleEditMode] = useToggle(false);
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState(null);
  // const [updateOrganisation] = useMutation(UPDATE_ORGANISATION);

  const registerSchema = yup.object({
    displayName: yup.string().required('Display name is required')
  });
  // load url using next router
  useEffect(() => {
    const location = router;
    // eslint-disable-next-line no-console
    console.log('router', location);
  }, [router.asPath]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleUpdateOrganisation = async (evt) => {
    // await updateOrganisation({
    //   variables: {
    //     input: {
    //       name: evt.displayName
    //     }
    //   }
    // }).catch((err) => {
    //   setError(err);
    // });

    toggleEditMode();
  };

  return (
    <PricingWrapper height='80'>
      {error && (
        <Alert status='error'>
          <AlertIcon />
        </Alert>
      )}
      <Formik
        validationSchema={registerSchema}
        // eslint-disable-next-line react/jsx-no-bind
        onSubmit={handleUpdateOrganisation}
        initialValues={{
          displayName: currentOrganisation.name
        }}
      >
        {({ isSubmitting, handleChange, errors, handleBlur }) => (
          <Form>
            <Flex direction='column' justify='center'>
              <Text fontSize='2xl' fontWeight='bold' pb='6'>
                Overview
              </Text>
              <Text size='md'>Display name</Text>
              {editMode ? (
                // <Stack spacing='-px' pt='4'>
                <Field name='displayName'>
                  {({ field, form }) => (
                    <FormControl
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={form.touched.displayName && !!form.errors.displayName}
                    >
                      <Input
                        {...field}
                        placeholder='display name'
                        id='displayName'
                        name='displayName'
                        type='text'
                        autoFocus
                      />
                      {/* @ts-ignore TODO: Fix */}
                      <FormErrorMessage mb={2}>{errors.displayName}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              ) : (
                // </Stack>
                <Text mt='2' color={useColorModeValue('brand.600', 'brand.400')} pb='4'>
                  {currentOrganisation.name}
                </Text>
              )}
              <Text size='md'>Created</Text>
              {/* @ts-ignore */}
              <Text mt='2' color={useColorModeValue('brand.600', 'brand.400')}>
                {dayjs(currentOrganisation.created).format('DD MMM YYYY')}
              </Text>
            </Flex>

            <div
              style={{
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bottom: 0,
                left: 0,
                width: '100%',
                marginBottom: '20px',
                marginTop: '20px'
              }}
            >
              <FeatureGuard usrScopes={[UserScopes.ORG_UPDATE]}>
                {editMode ? (
                  <Flex flexDir='row' justifyContent='space-between' w='100%' mt={4} mx={8}>
                    <Button
                      w='min-intrinsic'
                      minH='3.5rem'
                      rounded='lg'
                      fontWeight='bold'
                      colorScheme='brand'
                      variant='outline'
                      onClick={() => toggleEditMode(true)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type='submit'
                      w='min-intrinsic'
                      minH='3.5rem'
                      rounded='lg'
                      fontWeight='bold'
                      colorScheme='brand'
                      variant='outline'
                      isLoading={isSubmitting}
                      isDisabled={!!errors.displayName}
                    >
                      Save
                    </Button>
                  </Flex>
                ) : (
                  <Button
                    w='min-intrinsic'
                    minH='3.5rem'
                    rounded='lg'
                    fontWeight='bold'
                    colorScheme='brand'
                    variant='outline'
                    onClick={() => toggleEditMode(true)}
                  >
                    Manage organisation
                  </Button>
                )}
              </FeatureGuard>
              {/* <Link href={`/dashboard/${currentOrganisation.id}/subscribe`}> */}
              {/* </Link> */}
            </div>
          </Form>
        )}
      </Formik>
    </PricingWrapper>
  );
};

export default UpdateOrganization;
